<template>
  <div v-if="visible" class="mask" @click.self="$emit('close')">
    <div class="modal modal-lg script-preview-modal">
      <h3>预览剧本设定</h3>
      <div class="script-preview-scroll">
        <p class="script-preview-line">项目名称：{{ projectTitleDisplay }}</p>
        <p class="script-preview-line">画面风格：{{ styleLine }}</p>
        <p class="script-preview-line">画面比例：{{ ratioDisplay }}</p>
        <p class="script-preview-line">类型：{{ typeDisplay }}</p>
        <p class="script-preview-line">视频生成语言：{{ languageLineDisplay }}</p>
        <p v-if="referenceLineDisplay" class="script-preview-line">参考对象：{{ referenceLineDisplay }}</p>
        <p class="script-preview-line">预设集数：{{ episodeLine }}</p>
        <p class="script-preview-line">剧本生成方式：{{ scriptTypeLabel }}</p>
        <div v-if="hasScriptBody" class="script-preview-script-block">
          <div class="script-preview-subhead">剧本正文</div>
          <pre class="script-preview-script">{{ scriptContent }}</pre>
        </div>
        <p v-else class="script-preview-empty">暂无剧本正文</p>
      </div>
      <div class="modal-actions script-preview-actions">
        <button type="button" class="secondary-btn" @click="$emit('close')">关闭</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ScriptPreviewModal",
  props: {
    visible: { type: Boolean, default: false },
    projectTitle: { type: String, default: "" },
    styleLine: { type: String, default: "" },
    ratio: { type: String, default: "" },
    projectType: { type: String, default: "" },
    /** zh | en，与项目 video_prompt_language 一致 */
    videoPromptLanguage: { type: String, default: "zh" },
    episodeLine: { type: String, default: "" },
    scriptTypeLabel: { type: String, default: "" },
    scriptContent: { type: String, default: "" },
    referenceLine: { type: String, default: "" }
  },
  computed: {
    referenceLineDisplay() {
      return String(this.referenceLine || "").trim();
    },
    projectTitleDisplay() {
      return String(this.projectTitle || "").trim() || "（未填写）";
    },
    ratioDisplay() {
      return String(this.ratio || "").trim() || "—";
    },
    typeDisplay() {
      return String(this.projectType || "").trim() || "—";
    },
    languageLineDisplay() {
      return String(this.videoPromptLanguage || "").toLowerCase() === "en" ? "English（英文）" : "中文（默认）";
    },
    hasScriptBody() {
      return !!String(this.scriptContent || "").trim();
    }
  }
};
</script>

<style scoped>
/* 与 role-list 一致的滚动条（仅外层 .script-preview-scroll 滚动） */
.script-preview-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  margin: 12px 0 0;
  color: #d6d6d6;
  font-size: 14px;
  line-height: 1.65;
  text-align: left;
}

.script-preview-modal {
  width: min(720px, 92vw);
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  min-height: 0;
  box-sizing: border-box;
}

.script-preview-modal h3 {
  flex-shrink: 0;
  margin-top: 0;
}

.script-preview-line {
  margin: 0 0 10px;
}

.script-preview-subhead {
  margin: 14px 0 8px;
  color: #9f9f9f;
  font-size: 12px;
}

.script-preview-script-block {
  margin-top: 8px;
}

.script-preview-script {
  margin: 0;
  padding: 12px;
  border-radius: 10px;
  background: #1a1a1a;
  border: 1px solid #3a3a3a;
  color: #e8e8e8;
  font-size: 13px;
  white-space: pre-wrap;
  word-break: break-word;
  overflow: visible;
}

.script-preview-empty {
  margin: 8px 0 0;
  color: #888;
  font-size: 13px;
}

.script-preview-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
  flex-shrink: 0;
}
</style>
